<template>
  <div v-click-outside="handleClickOutside" :class="{ 'collapsed_menu bg-sky-800': is_collapsed }" class="p-0 collapsed_menu prevent-select" style="">
    <div v-if="!is_collapsed" class="is-fullheight has-text-white left_menu_scrollbar left-menu-wrap is-flex is-flex-direction-column" :class="[keep_open ? 'sticky-menu' : 'opened-menu']" style="">
      <p class="py-3 is-subtitle has-text-left">
        <span v-if="!keep_open">
          <!-- <i v-if="socket_connected" class="mr-2 fa fa-circle text-sky-600 fa-xs"></i> -->
          <a href="" @click.prevent="toggle_menu">
            <i class="mr-2 fa fa-bars fa-xs"></i>
          </a>
          {{ configs.company_name }}
        </span>
        <a href="" @click.prevent="toggleKeepOpen()" :class="[keep_open ? '' : 'is-pulled-right']">
          <i class="ml-2 mr-2 fa fa-thumbtack fa-xs" :class="[keep_open ? 'text-green-600' : 'text-gray-300']"></i>
        </a>
      </p>
      <ul class="flex-1 list" style="overflow-y: auto">
        <li v-for="(menu_item, index) in menu_items" :key="index" class="">
          <!-- {{'menu.can_see_' + menu_item.key}} - {{am_allowed('menu.can_see_' + menu_item.key)}} -->
          <div v-if="canSeeMenuSection(menu_item)" class="px-3 list-item is-flex is-flex-direction-column">
            <a @click.prevent="menu_item.collapsed = !menu_item.collapsed" :class="{ 'parent-item-collapsed': !menu_item.collapsed }" class="px-2 py-1 parent_item">
              <i class="fa" :class="menu_item.collapsed ? 'fa-angle-down' : 'fa-angle-up text-white'"></i>
              <span class="ml-3 font-bold menu-item-name is-uppercase" style="font-family: 'Varela', sans-serif">
                {{ menu_item.name }}
              </span>
            </a>
            <ul v-if="menu_item.items.length > 0 && !menu_item.collapsed" class="p-1 menu-sub-items-list">
              <li v-for="(item, indexa) in menu_item.items" :key="indexa" class="is-clickable">
                <div v-if="!item?.is_row" class="items-center justify-between pr-4 is-flex">
                  <a v-if="menu_item.key == 'processes' && item.route != '/process/activities'" :title="item.name + ' Krijo Dokument'" class="mr-2" @click.prevent="setPage(item.route + 'new')" :href="item.route + 'new'">
                    <i class="fa-solid fa-plus"></i>
                  </a>
                  <a
                    @click.prevent="menu_item.key == 'processes' ? null : setPage(item.route)"
                    class="items-start flex-1 is-flex"
                    :class="{ active: isRouteActive(item.route), 'cursor-default': menu_item.key == 'processes' }"
                    :href="item.route"
                  >
                    <i :class="item.icon_prefix" class="mt-2px" v-if="item.icon_prefix"></i>
                    <span class="flex-1 pl-1 menu-title">
                      {{ item.name }}
                    </span>
                    <!-- <span v-if="currentRoutePath == item.route && menu_item.name != 'Procese'"> -->
                    <!--   <i class="fa-solid fa-circle fa-xs text-sky-800"></i> -->
                    <!-- </span> -->
                  </a>
                  <a class="ml-2" v-if="menu_item.key == 'processes'" @click.prevent="setPage(item.route + 'list')" :href="item.route + 'list'" :title="item.name + ' Lista Documentave'">
                    <span> {{ item.item.total_open_documents }} <i class="fa-solid fa-list-ul"></i> </span>
                  </a>
                  <router-link v-if="menu_item.name == 'Procese'" :to="item.route + 'list'" class="is-pulled-right"> </router-link>
                </div>
                <div v-else>
                  <span class="row-name is-uppercase">{{ item.name }}</span>
                  <div class="is-flex is-flex-direction-row is-justify-content-space-between">
                    <div v-for="itema in item.items" :key="itema.name">
                      <a @click.prevent="setPage(itema.route)" class="is-flex is-flex-direction-column is-align-items-center" :class="{ active: isRouteActive(itema.route) }" :href="itema.route">
                        <i :class="itema.icon_prefix" v-if="itema.icon_prefix"></i>
                        <span style="font-family: 'Varela', sans-serif">
                          {{ itema.name }}
                        </span>
                      </a>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </li>
      </ul>
      <a @click.prevent="toggle_menu" v-if="!keep_open" class="menu_collapse_toggle_opened is-flex is-justify-content-center is-align-items-center" href="">
        <i class="fas" :class="[is_collapsed ? 'fa-chevron-right' : 'fa-chevron-left']"></i>
      </a>
    </div>
    <div @click="toggle_menu" class="is-fullheight has-text-white left_menu_scrollbar left-menu-wrap is-clickable is-flex" :class="[keep_open ? 'height-auto' : '']" style="position: relative; z-index: 9">
      <span v-if="!keep_open" class="menu_collapse_toggle bg-sky-800 is-flex is-justify-content-center is-align-items-center" style="margin-top: auto; position: sticky">
        <i class="fas" :class="[is_collapsed ? 'fa-chevron-right' : 'fa-chevron-left']"></i>
      </span>
      <span v-if="!keep_open" class="menu_vertical_text">
        {{ labelOf }}
      </span>
    </div>
  </div>
</template>

<script>
import { storeToRefs } from "pinia";
import { useMenuStore } from "@/stores/menu";
import { useConfigurationsStore } from "@/stores/configurations";
import { useCategoryStore } from "@/stores/category";
import ProcessServices from "@/services/Processes";
import { useProcessStore } from "@/stores/process";
import { useDiaryStore } from "@/stores/diary";

// import processService from '@/services/Processes'
import permissionMixin from "@/mixins/permissions-mixin.js";
import krudh from "@/components/krudh/";

import socket from "@/socket.js";

export default {
  components: [krudh],
  mixins: [permissionMixin],
  data() {
    return {
      divider: " • ",
      menu: {
        katalog: true,
        kliente: true,
        shitje: true,
      },
      keep_open: localStorage.getItem("keep_open") == "true" ? true : false,
      submenu: "",
      menu_store: storeToRefs(useMenuStore()),
      category_store: storeToRefs(useCategoryStore()),
      process_store: storeToRefs(useProcessStore()),
      diary_store: storeToRefs(useDiaryStore()),
      is_collapsed: localStorage.getItem("keep_open") == "true" ? false : true,
      processes_list: [],
      menu_items: [
        { name: "Katalog", key: "catalog", collapsed: true, items: [{ is_row: true, items: [], name: "Kategori" }] },
        { name: "Cmimet", key: "pricing", collapsed: true, items: [] },
        { name: "CRM", key: "crm", collapsed: true, items: [{ is_row: true, items: [], name: "Kategori" }] },
        { name: "Furnitore", key: "supplier", collapsed: true, items: [{ is_row: true, items: [], name: "Kategori" }] },
        { name: "Stock", key: "transactional", collapsed: true, items: [{ is_row: true, items: [], name: "Magazina" }] },
        { name: "Ditare", key: "diary", collapsed: true, items: [{ is_row: true, items: [], name: "" }] },
        { name: "Procese", key: "processes", collapsed: true, items: [] },
        { name: "Fatura", key: "invoices", collapsed: true, items: [{ is_row: true, items: [], name: "" }] },
        { name: "Flete pune", key: "jobs", collapsed: true, items: [{ is_row: true, items: [], name: "" }] },
        { name: "Rezervime", key: "reservations", collapsed: true, items: [{ is_row: true, items: [], name: "" }] },
        { name: "Konfigurime", key: "configurations", collapsed: true, items: [{ is_row: true, items: [], name: "Perdorues" }] },
      ],
      configs: storeToRefs(useConfigurationsStore()),
    };
  },
  watch: {
    labelOf: function (val) {
      this.$document.title = val;
    },
  },
  methods: {
    toggleKeepOpen() {
      this.keep_open = !this.keep_open;
      if (this.keep_open) {
        this.is_collapsed = false;
        localStorage.setItem("keep_open", true);
      } else {
        localStorage.removeItem("keep_open");
      }
    },
    handleClickOutside() {
      if (this.keep_open) {
        return;
      }
      if (!this.is_collapsed) {
        this.is_collapsed = true;
      }
    },
    setPage(page) {
      this.submenu = page;
      this.menu_store.submenu = page;
      this.$router.push({ path: "/loading..." });
      // console.log('setPage', page)

      if (page.includes("categories") || page.includes("attributes")) {
        this.category_store.list = [];
        this.category_store.flat_list = [];
        this.category_store.attributes = [];
        this.categories_attributes = [];
        this.categories_accessories = [];
        this.categories_service_types = [];
        this.attribute_types = [];
      } else if (page.includes("process/")) {
        // window.location.href = page
        this.process_store.process = {};
        this.process_store.current_step = {};
        this.process_store.process_steps = [];
        this.process_store.product_list = [];
        this.process_store.attributes = { origin: [], destinantion: [] };
      } else if (page.includes("diary")) {
        this.diary_store.diary = JSON.parse(JSON.stringify({}));
        this.diary_store.countdown = "";
        this.diary_store.diaries = [];
        this.diary_store.products = [];
        this.diary_store.customers = [];
        this.diary_store.comments = [];
      }
      setTimeout(() => {
        if (page.includes("?")) {
          const [path, queryStr] = page.split("?");
          const query = {};
          queryStr.split("&").forEach((part) => {
            const [k, v] = part.split("=");
            if (k && v != null) query[k] = decodeURIComponent(v || "");
          });
          this.$router.replace({ path, query });
        } else {
          this.$router.replace({ path: page });
        }
        this.toggle_menu();
      }, 200);
    },
    toggle_menu() {
      if (this.keep_open) {
        return;
      }
      this.is_collapsed = !this.is_collapsed;
    },
    isRouteActive(route) {
      if (!route) return false;
      if (route === this.$route.path && !route.includes("?")) return true;
      if (route.includes("?")) {
        const [rPath, rQuery] = route.split("?");
        if (this.$route.path !== rPath) return false;
        const params = {};
        rQuery.split("&").forEach((part) => {
          const [k, v] = part.split("=");
          if (k) params[k] = v ? decodeURIComponent(v) : "";
        });
        return Object.keys(params).every((k) => this.$route.query[k] === params[k]);
      }
      return this.$route.path === route;
    },
    canSeeMenuSection(menu_item) {
      if (!menu_item?.key) return false;
      if (menu_item.key === "pricing") {
        return (
          this.am_allowed("menu_roles.can_see_pricing") ||
          this.am_allowed("menu_roles.can_see_catalog_pricing") ||
          this.am_allowed("pricing.can_see_cmimet") ||
          this.am_allowed("pricing.can_see_oferta") ||
          this.am_allowed("pricing.can_see_calendar")
        );
      }
      if (menu_item.key === "invoices") {
        return (
          this.am_allowed("menu_roles.can_see_invoices") ||
          this.am_allowed("invoices.can_see_sales") ||
          this.am_allowed("invoices.can_see_purchases") ||
          this.am_allowed("invoices.can_see_creditnotes")
        );
      }
      if (menu_item.key === "processes") {
        return this.am_allowed("menu_roles.can_see_processes") || this.am_allowed("processes.can_see");
      }
      return this.am_allowed("menu_roles.can_see_" + menu_item.key);
    },
    canSeeInvoiceScreen(permission) {
      return this.am_allowed("invoices." + permission) || this.am_allowed("menu_roles.can_see_invoices");
    },
    canSeePricingScreen(permission) {
      return this.am_allowed("pricing." + permission) || this.am_allowed("menu_roles.can_see_catalog_pricing");
    },
    isFinancaStockAdmin() {
      try {
        const user = JSON.parse(localStorage.user || "null");
        const typeId = Number(user?.type_id ?? 0);
        return typeId === 1 || typeId === -1;
      } catch {
        return false;
      }
    },

    check_permissions() {
      if (localStorage.user != undefined) {
        this.menu_items.map((i) => {
          if (i.key == "catalog" && this.am_allowed("menu_roles.can_see_catalog")) {
            i.items[0].items.push({ icon_prefix: "fa fa-sitemap", name: "Produkti", route: "/categories/products" });
            i.items[0].items.push({ icon_prefix: "fa fa-sitemap", name: "Aksesori", route: "/categories/products?tab=accessories" });
            i.items[0].items.push({ icon_prefix: "fa fa-globe", name: "Online", route: "/categories/online" });
            i.items.push({
              is_row: true,
              name: "Attributes",
              items: [{ icon_prefix: "fa fa-diagram-project", name: "Atribute", route: "/attributes/products" }],
              // { icon_prefix: "fa fa-diagram-project", name: "Atribute", route: "/attributes/products" }
            });
            if (this.am_allowed("menu_roles.can_see_catalog_products")) {
              i.items.push({ icon_prefix: "fa fa-cubes-stacked", name: "Produkte dhe Aksesore", route: "/products" });
            }
            if (this.am_allowed("menu_roles.can_see_catalog_materials")) {
              i.items.push({ icon_prefix: "fa fa-shapes", name: "Materiale", route: "/materials" });
            }
            if (this.am_allowed("menu_roles.can_see_catalog_services")) {
              i.items.push({ icon_prefix: "fa fa-cog", name: "Sherbime", route: "/services" });
            }
          } else if (i.key == "pricing" && this.canSeeMenuSection(i)) {
            if (this.canSeePricingScreen("can_see_cmimet")) {
              i.items.push({ icon_prefix: "fa fa-tags", name: "Cmimet", route: "/cmimet" });
            }
            if (this.canSeePricingScreen("can_see_oferta")) {
              i.items.push({ icon_prefix: "fa fa-percent", name: "Oferta dhe Fushata", route: "/cmimet/oferta" });
            }
            if (this.canSeePricingScreen("can_see_calendar")) {
              i.items.push({ icon_prefix: "fa fa-calendar-alt", name: "Kalendari i cmimeve", route: "/cmimet/kalendar" });
            }
          } else if (i.key == "crm" && this.am_allowed("menu_roles.can_see_crm")) {
            i.items[0].items.push({ icon_prefix: "fa fa-sitemap", name: "Kategori", route: "/categories/customers" });
            i.items.push({ icon_prefix: "fa fa-users", name: "Kliente", route: "/customers" });
            i.items[0].items.push({ icon_prefix: "fa fa-diagram-project", name: "Atribute", route: "/attributes/customers" });
            i.items.push({ icon_prefix: "fa fa-user-friends", name: "Agjente shitje", route: "/sales_agents" });
            i.items.push({ icon_prefix: "fa fa-solid fa-list-ul", name: "Kerkese produktesh", route: "/free/line/products" });
          } else if (i.key == "supplier" && this.am_allowed("menu_roles.can_see_supplier")) {
            i.items[0].items.push({ icon_prefix: "fa fa-sitemap", name: "Kategori", route: "/categories/suppliers" });
            i.items.push({ icon_prefix: "fa fa-truck-field", name: "Furnitore", route: "/suppliers" });
            i.items[0].items.push({ icon_prefix: "fa fa-diagram-project", name: "Atribute", route: "/attributes/suppliers" });
          } else if (i.key == "transactional") {
            if (this.am_allowed("stock.can_see")) i.items.push({ icon_prefix: "fa fa-cubes", name: "Gjendja", route: "/stock" });
            if (this.am_allowed("stock_financa.can_see")) i.items.push({ icon_prefix: "fa fa-file-invoice-dollar", name: "Gjendja analitike", route: "/stock/financa" });
            if (this.am_allowed("stock_financa.can_see")) i.items.push({ icon_prefix: "fa fa-calendar-alt", name: "Kalendari i stokut", route: "/stock/financa/kalendar" });
            if (this.am_allowed("transactions.can_see_warehouses")) {
              i.items[0].items.push({ icon_prefix: "fa fa-warehouse", name: "Magazina", route: "/warehouses" });
              i.items[0].items.push({ icon_prefix: "fa fa-sitemap", name: "Kategori", route: "/categories/warehouses" });
            }
            if (this.am_allowed("transactions.can_see_pos")) i.items.push({ icon_prefix: "fa fa-store", name: "Pika shitje", route: "/pos/list" });
            if (this.am_allowed("menu_roles.can_see_reservations")) i.items.push({ icon_prefix: "fa fa-boxes-stacked", name: "Rezervime", route: "/manage_reservations" });
          } else if (i.key == "invoices") {
            if (this.canSeeInvoiceScreen("can_see_sales")) i.items[0].items.push({ icon_prefix: "fa fa-file-invoice", name: "Shitje", route: "/invoices/sale" });
            if (this.canSeeInvoiceScreen("can_see_purchases")) i.items[0].items.push({ icon_prefix: "fa fa-file-invoice-dollar", name: "Blerje", route: "/invoices/purchase" });
            if (this.canSeeInvoiceScreen("can_see_creditnotes")) i.items.push({ icon_prefix: "fa fa-file-lines", name: "Mandate", route: "/creditnotes" });
          } else if (i.key == "configurations") {
            if (this.am_allowed("user_roles.can_see_user")) i.items[0].items.push({ icon_prefix: "fa fa-user", name: "Perdorues", route: "/user-permissions/users" });
            if (this.am_allowed("user_roles.can_see_user_roles")) i.items[0].items.push({ icon_prefix: "fa fa-user-gear", name: "Role", route: "/user-permissions/roles" });
            if (this.am_allowed("processes.can_see") || this.am_allowed("menu_roles.can_see_processes")) {
              i.items.push({ icon_prefix: "fa fa-cog", name: "Procese", route: "/processes" });
            }
            if (this.am_allowed("menu_roles.can_see_processes") || this.am_allowed("menu_roles.can_see_configurations")) {
              i.items.push({ icon_prefix: "fa fa-file-lines", name: "Printime", route: "/process/print" });
            }
            if (this.am_allowed("menu_roles.can_see_configurations")) {
              i.items.push({ icon_prefix: "fa fa-upload", name: "Importe", route: "/importer" });
              i.items.push({ icon_prefix: "fa fa-building", name: "Sistemi", route: "/company" });
            }
            if (this.am_allowed("menu_roles.can_see_audit_logs")) {
              i.items.push({ icon_prefix: "fa fa-history", name: "Historik", route: "/audit-logs" });
            }
            if (this.isFinancaStockAdmin()) {
              i.items.push({ icon_prefix: "fa fa-flask", name: "Stok Financa test", route: "/stock/financa/admin" });
            }
            // i.items.push({ icon_prefix: 'fa-solid fa-clipboard-user', name: 'Burime njerezore', route: '/hr_home', })
          } else if (i.key == "diary") {
            if (this.am_allowed("diary_roles.can_create_diary")) {
              i.items[0].items.push({ icon_prefix: "fa fa-plus", name: "Krijo", route: "/diary/create" });
            }
            if (this.am_allowed("diary_roles.can_see_diary_list")) {
              i.items[0].items.push({ icon_prefix: "fa fa-calendar-alt", name: "Hapur", route: "/diary/list" });
            }
            if (this.am_allowed("diary_roles.can_see_diary_history")) {
              i.items[0].items.push({ icon_prefix: "fa fa-calendar-check", name: "Historik", route: "/diary/list/closed" });
            }
          } else if (i.key == "processes") {
            // remove if there are no processes allowed to be shown in menu
            if (this.processes_list.length == 0) {
              this.menu_items.splice(
                this.menu_items.findIndex((x) => x.key == "processes"),
                1
              );
            } else
              this.processes_list.map((p) => {
                if (p.show_in_menu) {
                  i.items.unshift({
                    name: p.name,
                    item: p,
                    route: "/process/" + p.guid + "/",
                    icon_prefix: p.icon,
                  });
                }
              });
          } else if (i.key == "jobs") {
            i.items[0].items.push({ icon_prefix: "fa fa-sitemap", name: "Menaxho", route: "/process/activities" });
            i.items[0].items.push({ icon_prefix: "fa fa-clipboard-list", name: "Lista", route: "/job/list" });
          } else if (i.key == "reservations") {
            i.items[0].items.push({ icon_prefix: "fa fa-clipboard-list", name: "Lista", route: "/reservation_temp/list" });
            // i.items[0].items.push({ icon_prefix: 'fa fa-sitemap', name: 'Magazina', route: '/process/activities', })
          }
        });
        this.menu_items = this.menu_items
          .map((item) => {
            item.items = (item.items || []).filter((sub) => !sub?.is_row || (sub.items && sub.items.length > 0));
            return item;
          })
          .filter((item) => !["pricing", "invoices", "transactional"].includes(item.key) || (item.items && item.items.length > 0));
      }
    },
  },
  async created() {
    this.processes_list = await ProcessServices.getProcesses();
    useProcessStore().processes_list = this.processes_list;
    this.check_permissions();
  },
  computed: {
    socket_connected() {
      return socket?.connected;
    },
    currentRoutePath() {
      return this.$route.path;
    },
    currentRouteName() {
      return this.$route.name;
    },
    labelOf() {
      var route = this.currentRoutePath;
      var label = [];
      this.menu_items.forEach((item) => {
        item.items.forEach((subitem) => {
          if (subitem.route == route) {
            if (!label.includes(item.name.toUpperCase())) label.push(item.name.toUpperCase());
            if (!label.includes(subitem.name.toUpperCase())) label.push(subitem.name.toUpperCase());
          } else if (subitem.route + "new" == route || subitem.route + "list" == route) {
            if (subitem.route + "new" == route) {
              if (!label.includes(item.name.toUpperCase())) label.push(item.name.toUpperCase());
              if (!label.includes(subitem.name.toUpperCase())) label.push(subitem.name.toUpperCase());
              if (!label.includes("KRIJO")) label.push("KRIJO");
            } else if (subitem.route + "list" == route) {
              if (!label.includes(item.name.toUpperCase())) label.push(item.name.toUpperCase());
              if (!label.includes(subitem.name.toUpperCase())) label.push(subitem.name.toUpperCase());
              if (!label.includes("LISTA")) label.push("LISTA");
            }
          } else if (subitem.items?.length > 0) {
            subitem.items.forEach((subsubitem) => {
              if (subsubitem.route == route) {
                if (!label.includes(item.name.toUpperCase())) label.push(item.name.toUpperCase());
                if (!label.includes(subitem.name.toUpperCase())) label.push(subitem.name.toUpperCase());
                if (!label.includes(subsubitem.name.toUpperCase())) label.push(subsubitem.name.toUpperCase());
              }
            });
          }
        });
      });
      if (label.length == 0 && route.includes("process/")) {
        label.push(this.process_store?.process?.name);
        // label.push(this.process_store?.current_step?.name )
        label.push(this.process_store?.process?.document_data?.process_number);
      }
      return label.filter((l) => l != "").join(this.divider);
    },
  },
};
</script>

<style scoped>
.list:not(.fa) .menu-title {
  font-family: "Manrope", sans-serif;
}
.mt-2px {
  margin-top: 2px;
}
.list-item {
  padding: 4px !important;
  border-bottom: 1px solid #4c4c4c;

  font-size: 11px !important;
  text-transform: uppercase;
}

.is-subtitle {
  /* company name in the menu */
  text-transform: uppercase;
  border-bottom: 1px solid #628fd7;
  padding: 5px 0px 5px 8px;
  margin-bottom: 15px;
}

.menu-sub-items-list i.fa {
  color: #628fd7;
}

.list-item .menu-item-name {
  float: right;
}

.list-item > ul {
  background: #1a22416e;
}

.list-item > ul > li {
  /* margin-left: 10px !important; */
  border: dotted;
  border-width: 0px 0px 1px 0px;
  padding: 5px 0px 5px 8px;
  border-color: #446f70;
}

.list-item > ul > li:last-child {
  border: none;
}
.prevent-select {
  -webkit-user-select: none; /* Safari */
  -ms-user-select: none; /* IE 10 and IE 11 */
  user-select: none; /* Standard syntax */
}
.list-item > ul > li:hover {
  color: #a4b4ff !important;
}

.list-item a:hover {
  color: yellow !important;
}

.active {
  font-weight: 600;
  color: #93c5fd !important;
  position: relative;
}

.active::after {
  content: "";
  position: absolute;
  right: -8px;
  top: 50%;
  transform: translateY(-50%);
  width: 3px;
  height: 90%;
  background: #3b82f6;
  border-radius: 2px;
}

.left-menu-wrap {
  background: #01070ad9;
  border-right: 1px solid grey;
  border-bottom: 1px solid grey;
  height: 100%;
  position: relative;
}

/* Scrollbar styles */
/* ===== Scrollbar CSS ===== */
/* Firefox */
.left_menu_scrollbar {
  scrollbar-width: auto;
  scrollbar-color: #dedede #ffffff;
}

/* Chrome, Edge, and Safari */
.left_menu_scrollbar::-webkit-scrollbar {
  width: 10px;
}

.left_menu_scrollbar::-webkit-scrollbar-track {
  background: #ffffff;
}

.left_menu_scrollbar::-webkit-scrollbar-thumb {
  background-color: #dedede;
  border-radius: 10px;
  border: 3px solid #ffffff;
}

/* End Scrollbar styles */

/* Collapsed Meny styles */
.collapsed_menu {
  max-width: fit-content;
  position: relative;
  min-width: 40px;
  width: fit-content;
}

.menu_collapse_toggle {
  position: absolute;
  bottom: 0px !important;
  left: 0px;
  color: #fff;
  text-align: center;
  width: inherit;
  min-width: 35px;
  z-index: 999;
  width: 100%;
  min-height: 40px;
}

.menu_collapse_toggle_opened {
  color: #fff;
  text-align: center;
  width: inherit;
  min-width: 35px;
  z-index: 999;
  width: 100%;
  min-height: 35px;
}

.menu_vertical_text {
  width: fit-content;
  white-space: pre;
  text-transform: capitalize;
  letter-spacing: 4px;

  position: absolute;
  top: calc(100vh - 150px);
  left: 5px;
  transform-origin: 0 0;
  transform: rotate(270deg);
}

.opened-menu {
  position: fixed;
  left: 0px;
  top: 0px;
  z-index: 99999;
  height: 100vh;
  width: 15%;
  padding-top: ;
}

.menu-sub-items-list {
}
.parent_item {
  transition: all 0.2s ease;
}
.parent-item-collapsed {
  background: rgba(255, 136, 0, 0.15);
  border-left: 2px solid #f59e0b;
}

.row-name {
  font-weight: bold;
  color: #fff;
  position: relative;
  top: -6px;
  font-size: 10px;
}

.height-auto {
  height: auto;
}

/* MEDIA QUERY START ****************************************************/

@media all and (min-width: 1024px) and (max-width: 1280px) {
}

@media all and (min-width: 768px) and (max-width: 1024px) {
  .opened-menu {
    width: 25%;
  }
}

@media all and (min-width: 480px) and (max-width: 768px) {
  .opened-menu {
    width: 45%;
  }
}

@media all and (max-width: 480px) {
  .opened-menu {
    width: 100%;
  }
}
</style>
